(function () {
  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function isProductOnSale(product) {
    if (!product) return false;
    if (product.compare_at_price != null && product.price != null) {
      return product.compare_at_price > product.price;
    }
    if (product.variants && product.variants.length) {
      return product.variants.some(function (variant) {
        return variant.compare_at_price != null && variant.compare_at_price > variant.price;
      });
    }
    return false;
  }

  function getProductImageSrc(product) {
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (product.image && product.image.src) return product.image.src;
    if (product.images && product.images.length) return product.images[0].src || product.images[0];
    if (product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.src) {
      return product.featured_media.preview_image.src;
    }
    return '';
  }

  function getProductPrice(product) {
    if (product.price != null) return product.price;
    if (product.variants && product.variants.length) return product.variants[0].price;
    return 0;
  }

  function destroyExistingSlider(placeholder) {
    var existingSlider = placeholder.querySelector('[data-cart-upsell-slider]');
    if (!existingSlider || typeof Flickity === 'undefined') return;

    var existingFlkty = Flickity.data(existingSlider);
    if (existingFlkty) existingFlkty.destroy();
  }

  function syncRecommendationsUrl(container, cart) {
    if (!cart || !cart.items || !cart.items.length) {
      container.style.display = 'none';
      return false;
    }

    var lastItem = cart.items[cart.items.length - 1];
    var url =
      '/recommendations/products.json?product_id=' +
      lastItem.product_id +
      '&limit=10&intent=related';

    container.setAttribute('data-recommendations-url', url);
    container.style.display = '';
    return true;
  }

  function initCartUpsell() {
    var container = document.querySelector('[data-cart-upsell]');
    if (!container) return;

    var placeholder = container.querySelector('[data-cart-upsell-placeholder]');
    if (!placeholder) return;

    var url = container.getAttribute('data-recommendations-url');
    if (!url) return;

    destroyExistingSlider(placeholder);

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        if (!payload || !payload.products || !payload.products.length) {
          container.style.display = 'none';
          return;
        }

        var products = payload.products.filter(function (product) {
          return !isProductOnSale(product);
        }).slice(0, 6);

        if (!products.length) {
          container.style.display = 'none';
          return;
        }

        var moneyFormat =
          (window.theme && theme.settings && theme.settings.moneyFormat) ||
          '${{amount}}';
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        var sliderEl = document.createElement('div');
        sliderEl.className = 'cart-upsell__slider';
        sliderEl.setAttribute('data-cart-upsell-slider', '');

        products.forEach(function (product) {
          var href = product.url || (rootUrl.replace(/\/$/, '') + '/products/' + (product.handle || ''));
          var price = getProductPrice(product);
          var formattedPrice = '';

          try {
            if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
              formattedPrice = theme.Currency.formatMoney(price, moneyFormat);
            } else {
              formattedPrice = (price / 100).toFixed(2);
            }
          } catch (e) {
            formattedPrice = (price / 100).toFixed(2);
          }

          var imgSrc = getProductImageSrc(product);
          var title = escapeHtml(product.title || '');
          var productId = product.id || '';

          var slideEl = document.createElement('div');
          slideEl.className = 'cart-upsell__slide';

          var cardHtml =
            '<div class="grid-product ' + (!product.available ? 'sold' : '') + '" data-product-handle="' + escapeHtml(product.handle || '') + '" data-product-id="' + productId + '">' +
            '  <div class="grid-product__content">' +
            '    <div class="grid__item-image-wrapper">' +
            '      <div class="grid-product__image-mask">' +
            '        <div class="image-wrap" style="height:0;padding-bottom:133.75%;">';

          if (imgSrc) {
            cardHtml +=
              '          <img src="' + escapeHtml(imgSrc) + '" alt="' + title + '" class="grid-product__image image-style--" loading="lazy" width="500" sizes="(min-width:769px) 20vw, 39vw">';
          } else {
            cardHtml +=
              '          <div class="product-image--placeholder"><span aria-hidden="true">—</span></div>';
          }

          var priceHtml = (formattedPrice && formattedPrice.indexOf('<') !== -1)
            ? formattedPrice
            : '<span class="money">' + escapeHtml(formattedPrice) + '</span>';

          cardHtml +=
            '        </div>' +
            '      </div>' +
            '      <a href="' + escapeHtml(href) + '" class="grid-product__link">' +
            '        <div class="grid-product__meta">' +
            '          <div class="grid-product__title grid-product__title--body">' + title + '</div>' +
            '          <div class="grid-product__price">' + priceHtml + '</div>' +
            '        </div>' +
            '      </a>' +
            '    </div>' +
            '  </div>' +
            '</div>';

          slideEl.innerHTML = cardHtml;
          sliderEl.appendChild(slideEl);
        });

        placeholder.innerHTML = '';
        placeholder.appendChild(sliderEl);

        var slideWidthPx = 70;
        if (typeof window.matchMedia !== 'undefined' && window.matchMedia('(min-width:769px)').matches) {
          slideWidthPx = 100;
        }

        for (var i = 0; i < sliderEl.children.length; i++) {
          sliderEl.children[i].style.width = slideWidthPx + 'px';
          sliderEl.children[i].style.minWidth = slideWidthPx + 'px';
          sliderEl.children[i].style.marginRight = '12px';
        }

        if (typeof Flickity !== 'undefined' && sliderEl.children.length) {
          try {
            var flkty = new Flickity(sliderEl, {
              cellAlign: 'left',
              contain: true,
              pageDots: false,
              prevNextButtons: true,
              wrapAround: false,
              groupCells: false,
              percentPosition: false,
              cellSelector: '.cart-upsell__slide',
              resize: true
            });

            if (flkty && typeof flkty.resize === 'function') {
              setTimeout(function () { flkty.resize(); }, 100);
            }
          } catch (e) {
            // Flickity optional; cards still render without slider
          }
        }
      })
      .catch(function () {
        container.style.display = 'none';
      });
  }

  function refreshCartUpsell(cart) {
    var container = document.querySelector('[data-cart-upsell]');
    if (!container) return;

    if (cart && syncRecommendationsUrl(container, cart)) {
      initCartUpsell();
      return;
    }

    fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cartData) {
        if (syncRecommendationsUrl(container, cartData)) {
          initCartUpsell();
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUpsell);
  } else {
    initCartUpsell();
  }

  document.addEventListener('cart:updated', function (evt) {
    refreshCartUpsell(evt.detail && evt.detail.cart);
  });

  document.addEventListener('drawerOpen.CartDrawer', function () {
    refreshCartUpsell();
  });

  window.initCartUpsell = initCartUpsell;
})();
